import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../redux/store";
import { AddUser, UsersList, ViewUser } from "../Components/users";
import {
  getAllUsers,
  onChangeUsersScreen,
} from "../redux/slices/users.slice";
import { isViewOnlyRole } from "../utils/rbac";

const Users = () => {
  const { data, currentScreen, selectedUser } = useSelector(
    (state: RootState) => state.users,
  );
  const { data: user } = useSelector((state: RootState) => state.auth);

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (
      isViewOnlyRole(user?.UserRole) &&
      (currentScreen === "add" || currentScreen === "update")
    ) {
      dispatch(onChangeUsersScreen("list"));
    }
  }, [currentScreen, dispatch, user?.UserRole]);

  useEffect(() => {
    if (!data?.length) {
      dispatch(getAllUsers());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCurrentScreen = (screen: string) => {
    switch (screen) {
      case "list":
        return <UsersList />;
      case "add":
        return <AddUser isEdit={false} defaultData={selectedUser} />;
      case "view":
        return <ViewUser />;
      case "edit":
      case "update":
        return <AddUser isEdit={true} defaultData={selectedUser} />;
    }
  };
  return (
    <div className="min-h-fit p-4 pt-3">{getCurrentScreen(currentScreen)}</div>
  );
};

export default Users;
